/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';

import { WorkAiServiceDto } from '../models/work-ai-service-dto';
import { WorkAiServiceTestResultDto } from '../models/work-ai-service-test-result-dto';
import { WorkAiServiceUsageDto } from '../models/work-ai-service-usage-dto';
import { WorkCheckAiServiceDto } from '../models/work-check-ai-service-dto';
import { WorkSaveAiServiceDto } from '../models/work-save-ai-service-dto';

@Injectable({ providedIn: 'root' })
export class WorkAiServicesV2Service extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `aiServicesV2ControllerFindAll()` */
  static readonly AiServicesV2ControllerFindAllPath = '/v2/ai-services';

  /**
   * Required permissions: all:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `aiServicesV2ControllerFindAll()` instead.
   *
   * This method doesn't expect any request body.
   */
  aiServicesV2ControllerFindAll$Response(
    params?: {
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<WorkAiServiceDto>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkAiServicesV2Service.AiServicesV2ControllerFindAllPath, 'get');
    if (params) {
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkAiServiceDto>>;
      })
    );
  }

  /**
   * Required permissions: all:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `aiServicesV2ControllerFindAll$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  aiServicesV2ControllerFindAll(
    params?: {
    },
    context?: HttpContext
  ): Observable<Array<WorkAiServiceDto>> {
    return this.aiServicesV2ControllerFindAll$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkAiServiceDto>>): Array<WorkAiServiceDto> => r.body)
    );
  }

  /** Path part for operation `aiServicesV2ControllerCreate()` */
  static readonly AiServicesV2ControllerCreatePath = '/v2/ai-services';

  /**
   * Required permissions: all:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `aiServicesV2ControllerCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  aiServicesV2ControllerCreate$Response(
    params: {
      body: WorkSaveAiServiceDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkAiServiceDto>> {
    const rb = new RequestBuilder(this.rootUrl, WorkAiServicesV2Service.AiServicesV2ControllerCreatePath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkAiServiceDto>;
      })
    );
  }

  /**
   * Required permissions: all:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `aiServicesV2ControllerCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  aiServicesV2ControllerCreate(
    params: {
      body: WorkSaveAiServiceDto
    },
    context?: HttpContext
  ): Observable<WorkAiServiceDto> {
    return this.aiServicesV2ControllerCreate$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkAiServiceDto>): WorkAiServiceDto => r.body)
    );
  }

  /** Path part for operation `aiServicesV2ControllerUsage()` */
  static readonly AiServicesV2ControllerUsagePath = '/v2/ai-services/usage';

  /**
   * Required permissions: all:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `aiServicesV2ControllerUsage()` instead.
   *
   * This method doesn't expect any request body.
   */
  aiServicesV2ControllerUsage$Response(
    params?: {
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkAiServiceUsageDto>> {
    const rb = new RequestBuilder(this.rootUrl, WorkAiServicesV2Service.AiServicesV2ControllerUsagePath, 'get');
    if (params) {
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkAiServiceUsageDto>;
      })
    );
  }

  /**
   * Required permissions: all:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `aiServicesV2ControllerUsage$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  aiServicesV2ControllerUsage(
    params?: {
    },
    context?: HttpContext
  ): Observable<WorkAiServiceUsageDto> {
    return this.aiServicesV2ControllerUsage$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkAiServiceUsageDto>): WorkAiServiceUsageDto => r.body)
    );
  }

  /** Path part for operation `aiServicesV2ControllerUpdate()` */
  static readonly AiServicesV2ControllerUpdatePath = '/v2/ai-services/{id}';

  /**
   * Required permissions: all:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `aiServicesV2ControllerUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  aiServicesV2ControllerUpdate$Response(
    params: {
      id: number;
      body: WorkSaveAiServiceDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkAiServiceDto>> {
    const rb = new RequestBuilder(this.rootUrl, WorkAiServicesV2Service.AiServicesV2ControllerUpdatePath, 'put');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkAiServiceDto>;
      })
    );
  }

  /**
   * Required permissions: all:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `aiServicesV2ControllerUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  aiServicesV2ControllerUpdate(
    params: {
      id: number;
      body: WorkSaveAiServiceDto
    },
    context?: HttpContext
  ): Observable<WorkAiServiceDto> {
    return this.aiServicesV2ControllerUpdate$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkAiServiceDto>): WorkAiServiceDto => r.body)
    );
  }

  /** Path part for operation `aiServicesV2ControllerRemove()` */
  static readonly AiServicesV2ControllerRemovePath = '/v2/ai-services/{id}';

  /**
   * Required permissions: all:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `aiServicesV2ControllerRemove()` instead.
   *
   * This method doesn't expect any request body.
   */
  aiServicesV2ControllerRemove$Response(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<void>> {
    const rb = new RequestBuilder(this.rootUrl, WorkAiServicesV2Service.AiServicesV2ControllerRemovePath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(
      rb.build({ responseType: 'text', accept: '*/*', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Required permissions: all:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `aiServicesV2ControllerRemove$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  aiServicesV2ControllerRemove(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<void> {
    return this.aiServicesV2ControllerRemove$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `aiServicesV2ControllerCheck()` */
  static readonly AiServicesV2ControllerCheckPath = '/v2/ai-services/check';

  /**
   * Required permissions: all:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `aiServicesV2ControllerCheck()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  aiServicesV2ControllerCheck$Response(
    params: {
      body: WorkCheckAiServiceDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkAiServiceTestResultDto>> {
    const rb = new RequestBuilder(this.rootUrl, WorkAiServicesV2Service.AiServicesV2ControllerCheckPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkAiServiceTestResultDto>;
      })
    );
  }

  /**
   * Required permissions: all:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `aiServicesV2ControllerCheck$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  aiServicesV2ControllerCheck(
    params: {
      body: WorkCheckAiServiceDto
    },
    context?: HttpContext
  ): Observable<WorkAiServiceTestResultDto> {
    return this.aiServicesV2ControllerCheck$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkAiServiceTestResultDto>): WorkAiServiceTestResultDto => r.body)
    );
  }

  /** Path part for operation `aiServicesV2ControllerTest()` */
  static readonly AiServicesV2ControllerTestPath = '/v2/ai-services/{id}/test';

  /**
   * Required permissions: all:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `aiServicesV2ControllerTest()` instead.
   *
   * This method doesn't expect any request body.
   */
  aiServicesV2ControllerTest$Response(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkAiServiceTestResultDto>> {
    const rb = new RequestBuilder(this.rootUrl, WorkAiServicesV2Service.AiServicesV2ControllerTestPath, 'post');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkAiServiceTestResultDto>;
      })
    );
  }

  /**
   * Required permissions: all:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `aiServicesV2ControllerTest$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  aiServicesV2ControllerTest(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<WorkAiServiceTestResultDto> {
    return this.aiServicesV2ControllerTest$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkAiServiceTestResultDto>): WorkAiServiceTestResultDto => r.body)
    );
  }

}
